import { useMemo } from "react";

import useTableSort from "components/Table/useTableSort";

import {
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
  MODULE_VERSION_SUBMODULES_TABLE_FILTERS_STORAGE_KEY,
  SORT_CONFIG,
} from "./constants";
import { sortModuleVersionSubmodules } from "./helpers";
import { ModuleVersionSubmoduleRow } from "./types";

export const useSortingModuleVersionSubmodules = (submodules: ModuleVersionSubmoduleRow[] = []) => {
  const { sortDescriptor } = useTableSort({
    filtersOrderSettingsKey: MODULE_VERSION_SUBMODULES_TABLE_FILTERS_STORAGE_KEY,
    sortConfig: SORT_CONFIG,
    initialSortOption: INITIAL_SORT_OPTION,
    initialSortDirection: INITIAL_SORT_DIRECTION,
  });

  return useMemo(
    () => sortModuleVersionSubmodules(submodules, sortDescriptor),
    [submodules, sortDescriptor]
  );
};
